/**
 * attachments.js
 * Path: frontend/src/utils/attachments.js
 * Description: Pomocnicze rozpoznawanie typów i formatowanie danych załączników.
 * Related: components/AttachmentList.jsx, components/JobChat.jsx
 */

const IMAGE_EXTENSIONS = /\.(png|jpe?g|webp|gif|heic|heif|bmp)$/i;
const VIDEO_EXTENSIONS = /\.(mp4|mov|webm|ogg|ogv|mkv|3gp|m4v)$/i;

export function isImageAttachment(attachment = {}) {
  const mime = String(attachment.mimeType || "");
  const name = String(attachment.originalName || "");
  return mime.startsWith("image/") || IMAGE_EXTENSIONS.test(name);
}

export function isVideoAttachment(attachment = {}) {
  const mime = String(attachment.mimeType || "");
  const name = String(attachment.originalName || "");
  return mime.startsWith("video/") || VIDEO_EXTENSIONS.test(name);
}

export function formatAttachmentSize(bytes) {
  const size = Number(bytes || 0);
  if (!size) {
    return "";
  }
  if (size >= 1024 * 1024 * 1024) {
    return `${(size / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  }
  if (size >= 1024 * 1024) {
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  }
  return `${Math.round(size / 1024)} KB`;
}
